import * as React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import { TransitionProps } from '@mui/material/transitions';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import FindYourAccount from './FindYourAccount';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});



const FindYourAccountPopup = ({ isOpened }: any) => {
    const location = useLocation();
    const history = useHistory();

    return (
        <>
            <div>
                <Dialog
                    className="findYourAccount_modal"
                    sx={{ "& .MuiDialog-paper": { backgroundColor: "#f5f4f9" } }}
                    fullScreen
                    disableEscapeKeyDown={true}
                    TransitionComponent={Transition}
                    open={isOpened}
                    onClose={history.goBack}
                >
                    <div className='findYourAccount-container' style={{ overflowY: "auto" }}>
                        <FindYourAccount />
                    </div>

                </Dialog>
            </div>
        </>


    )
}


export default FindYourAccountPopup;